module.exports = "pegasus/assets/f-icon2.png";